import { db } from './config';
import { doc, getDoc, setDoc, updateDoc, increment } from 'firebase/firestore';

export const firebaseOperations = {
  // Get current reaction counts
  getReactions: async () => {
    try {
      const docRef = doc(db, 'reactions', 'patient-feedback');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        // Initialize document if it doesn't exist
        const initialData = { happy: 0, unhappy: 0, total: 0 };
        await setDoc(docRef, initialData);
        return initialData;
      }
    } catch (error) {
      console.error('Error getting reactions:', error);
      throw error;
    }
  },

  // Add a new reaction
  addReaction: async (type) => {
    try {
      const docRef = doc(db, 'reactions', 'patient-feedback');
      
      // Update the counts
      await updateDoc(docRef, {
        [type]: increment(1),
        total: increment(1),
        lastUpdated: new Date().toISOString()
      });

      // Return updated data
      return await firebaseOperations.getReactions();
    } catch (error) {
      console.error('Error adding reaction:', error);
      throw error;
    }
  },

  // Reset reactions (admin function)
  resetReactions: async () => {
    try {
      const docRef = doc(db, 'reactions', 'patient-feedback');
      await setDoc(docRef, { 
        happy: 0, 
        unhappy: 0, 
        total: 0,
        lastReset: new Date().toISOString()
      });
      return { happy: 0, unhappy: 0, total: 0 };
    } catch (error) {
      console.error('Error resetting reactions:', error);
      throw error;
    }
  }
};